import PropTypes from 'prop-types';
import { DatePicker } from 'antd';
import dayjs from 'dayjs';
import locale from 'antd/es/date-picker/locale/vi_VN';
import { useTranslation } from 'react-i18next';
const { RangePicker } = DatePicker;

export const RangePresets = () => {
  const { t } = useTranslation('common');
  return [
    { label: t('homnay'), value: [dayjs(), dayjs()] },
    { label: t('homqua'), value: [dayjs().add(-1, 'd'), dayjs().add(-1, 'd')] },
    { label: t('7ngaytruoc'), value: [dayjs().add(-7, 'd'), dayjs()] },
    { label: t('14ngaytruoc'), value: [dayjs().add(-14, 'd'), dayjs()] },
    { label: t('30ngaytruoc'), value: [dayjs().add(-30, 'd'), dayjs()] },
    { label: t('90ngaytruoc'), value: [dayjs().add(-90, 'd'), dayjs()] },
  ];
};

export default function RangeDatePicker({ onChange, className = 'w-full', style }) {
  const { t } = useTranslation('common');
  const onRangeChange = (dates, dateStrings) => {
    if (dates) {
      onChange(dateStrings);
    }
  };
  const rangePresets = RangePresets();
  return (
    <div className="flex flex-col">
      {/* <label htmlFor="" className="my-2">
        {t("khoangthoigian")}:
      </label> */}
      <RangePicker
        locale={locale}
        placeholder={[t('ngaybatdau'), t('ngayketthuc')]}
        className={className}
        showTime={{
          defaultValue: [dayjs('00:00:00', 'HH:mm:ss'), dayjs('23:59:59', 'HH:mm:ss')],
        }}
        format="YYYY-MM-DD HH:mm:ss"
        defaultValue={[dayjs().add(-7, 'd'), dayjs()]}
        presets={rangePresets}
        onChange={onRangeChange}
        style={style}
      />
    </div>
  );
}

RangeDatePicker.propTypes = {
  onChange: PropTypes.func,
};
